// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Events_events__pI5RN {
  margin-top: 130px;
  margin-bottom: 50px;
}
.Events_events__pI5RN p.Events_text__q2grb {
  max-width: 800px;
  margin: 20px 0 50px 0;
}
.Events_events__pI5RN .Events_items__e5o\\+x {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
@media (max-width: 780px) {
  .Events_events__pI5RN .Events_items__e5o\\+x {
    gap: 100px;
  }
}
@media (max-width: 550px) {
  .Events_events__pI5RN .Events_items__e5o\\+x {
    gap: 80px;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_items__e5o\\+x {
    gap: 60px;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n {
  position: relative;
  background-color: var(--red);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n {
    gap: 20px;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_index__EQkPy {
  padding: 0 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_index__EQkPy {
    padding: 0 10px 0 20px;
  }
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_index__EQkPy {
    display: none;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_index__EQkPy h3 {
  font-size: 7.5rem;
  margin: 0;
  font-family: "Rubik Glitch";
  font-weight: 400;
  color: var(--white);
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_index__EQkPy h3 {
    font-size: 6.8rem;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  padding: 0 20px 0 0;
}
@media (max-width: 780px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS .Events_btn__3g9VQ {
    position: absolute;
    border: 0;
    top: calc(100% + 15px);
    right: -10px;
  }
}
@media (max-width: 780px) and (max-width: 480px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS .Events_btn__3g9VQ {
    top: calc(100% + 5px);
    right: -12px;
  }
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS {
    padding: 0 20px 0 5px;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS {
    padding: 0 10px 0 2px;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS h2 {
  font-family: "Beer money";
  font-size: 2rem;
  font-weight: 400;
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS h2 {
    font-size: 1.9rem;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS h2 {
    font-size: 1.7rem;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS h2,
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_box_info__gvnjS p {
  color: var(--white);
  margin: 0;
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx img {
  box-sizing: border-box;
  height: 100%;
  max-height: 320px;
  border: 10px solid var(--white);
  border-radius: 50%;
}
@media (max-width: 780px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx img {
    border: 8px solid var(--white);
    transform: scale(1.2);
  }
}
@media (max-width: 550px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx img {
    border: 5px solid var(--white);
  }
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx {
    max-height: 260px;
    max-width: 260px;
  }
}
@media (max-width: 1080px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx {
    max-height: 200px;
    max-width: 200px;
  }
}
@media (max-width: 550px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx {
    max-height: 140px;
    max-width: 140px;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n .Events_foto__S0xQx {
    max-height: 100px;
    max-width: 100px;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(odd) {
  margin-right: 100px;
  border-radius: 0 200px 200px 0;
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(odd) .Events_foto__S0xQx {
  margin-right: -15px;
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(odd) {
    margin-right: 40px;
  }
}
@media (max-width: 780px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(odd) {
    margin-right: 20px;
    border-radius: 40px 200px 200px 40px;
  }
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) {
  margin-left: 100px;
  flex-direction: row-reverse;
  width: 100%;
  border-radius: 200px 0 0 200px;
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) .Events_index__EQkPy {
  margin-right: 200px;
}
.Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) .Events_foto__S0xQx {
  margin-left: -15px;
}
@media (max-width: 1350px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) {
    margin-left: 40px;
    width: calc(100% + 60px);
  }
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) .Events_index__EQkPy {
    margin-right: 150px;
  }
}
@media (max-width: 780px) {
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) {
    margin-left: 0px;
    margin-right: 20px;
    flex-direction: row;
    width: 100%;
    border-radius: 40px 200px 200px 40px;
  }
  .Events_events__pI5RN .Events_items__e5o\\+x .Events_item__-ny2n:nth-child(even) .Events_index__EQkPy {
    margin-right: 0px;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl {
  position: fixed;
  inset: 0;
  background: rgba(217, 217, 217, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  z-index: 105;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  max-height: 100%;
  overflow-y: auto;
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_bg_height__TH7ab {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl {
    padding: 40px 20px;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka {
  border: 5px solid var(--red);
  background-color: var(--white);
  position: relative;
  margin: 50px 100px;
  padding: 5vh 3rem;
  box-sizing: border-box;
}
@media (max-width: 1420px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka {
    margin: 50px 20px;
  }
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka {
    margin: 0px 0px !important;
    padding: 4vh 1.5rem;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(26, 24, 47, 0.15);
  border-radius: 5px;
  height: 200px;
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka::-webkit-scrollbar-thumb {
  background: rgba(255, 0, 0, 0.101);
  border-radius: 8px;
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka h2 {
  font-family: "Beer money";
  font-weight: 400;
  margin: 0;
  max-width: 90%;
  font-size: 2rem;
}
@media (max-width: 768px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka h2 {
    max-width: 80%;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka h2 strong {
  color: var(--red);
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_close__xI-AI {
  position: absolute;
  top: 25px;
  right: 25px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--red);
  border-radius: 50%;
  cursor: pointer;
  border: none;
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_close__xI-AI {
    top: 15px;
    right: 15px;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_close__xI-AI i {
  font-size: 25px;
  color: var(--white);
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH {
  display: flex;
  align-items: center;
}
@media (max-width: 920px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH {
    display: block;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH {
    display: flex;
    flex-direction: column;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ,
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_2__jz\\+\\+N {
  width: 25%;
  max-width: 350px;
}
@media (max-width: 920px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ,
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_2__jz\\+\\+N {
    margin: 0;
    width: 50%;
    max-width: 350px;
  }
}
@media (max-width: 640px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ,
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_2__jz\\+\\+N {
    max-width: 250px;
  }
}
@media (max-width: 480px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ,
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_2__jz\\+\\+N {
    width: 100%;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ {
  margin: 150px -90px 10px 10px;
  z-index: 2;
}
@media (max-width: 1280px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ {
    margin: 120px -70px 10px 10px;
  }
}
@media (max-width: 920px) {
  .Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_1__cplHJ {
    margin: 0 -20px 0 0;
  }
}
.Events_events__pI5RN .Events_bg_popup__hwAPl .Events_box_popup__al\\+Ka .Events_col__CCIbH .Events_img_card_2__jz\\+\\+N {
  margin: 10px 0;
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/components/Events/Events.module.scss"],"names":[],"mappings":"AAAA;EACG,iBAAA;EACA,mBAAA;AACH;AAEG;EACG,gBAAA;EACA,qBAAA;AAAN;AAGG;EACG,aAAA;EACA,sBAAA;EACA,SAAA;AADN;AAGM;EALH;IAMM,UAAA;EAAP;AACF;AAEM;EATH;IAUM,SAAA;EACP;AACF;AACM;EAbH;IAcM,SAAA;EAEP;AACF;AAAM;EACG,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAET;AAAS;EARH;IASM,SAAA;EAGV;AACF;AADS;EACG,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AADY;EANH;IAOM,sBAAA;EAIb;AACF;AAFY;EAVH;IAWM,aAAA;EAKb;AACF;AAHY;EACG,iBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AAKf;AAHe;EAPH;IAQM,iBAAA;EAMhB;AACF;AAFS;EACG,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAIZ;AAFY;EACG;IACG,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,YAAA;EAIhB;AACF;AAHkB;EANH;IAOM,qBAAA;IACA,YAAA;EAMnB;AACF;AAFY;EAvBH;IAwBM,qBAAA;EAKb;AACF;AAHY;EA3BH;IA4BM,qBAAA;EAMb;AACF;AAJY;EACG,yBAAA;EACA,eAAA;EACA,gBAAA;AAMf;AAJe;EALH;IAMM,iBAAA;EAOhB;AACF;AALe;EATH;IAUM,iBAAA;EAQhB;AACF;AALY;;EAEG,mBAAA;EACA,SAAA;AAOf;AAFY;EACG,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AAIf;AAFe;EAPH;IAQM,8BAAA;IACA,qBAAA;EAKhB;AACF;AAHe;EAZH;IAaM,8BAAA;EAMhB;AACF;AAHY;EAlBH;IAmBM,iBAAA;IACA,gBAAA;EAMb;AACF;AAJY;EAvBH;IAwBM,iBAAA;IACA,gBAAA;EAOb;AACF;AALY;EA5BH;IA6BM,iBAAA;IACA,gBAAA;EAQb;AACF;AANY;EAjCH;IAkCM,iBAAA;IACA,gBAAA;EASb;AACF;AAJM;EACG,mBAAA;EACA,8BAAA;AAMT;AAJS;EACG,mBAAA;AAMZ;AAHS;EARH;IASM,kBAAA;EAMV;AACF;AAJS;EAZH;IAaM,kBAAA;IACA,oCAAA;EAOV;AACF;AAHM;EACG,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,8BAAA;AAKT;AAHS;EACG,mBAAA;AAKZ;AAFS;EACG,kBAAA;AAIZ;AADS;EAdH;IAeM,iBAAA;IACA,wBAAA;EAIV;EAFU;IACG,mBAAA;EAIb;AACF;AAAS;EAxBH;IAyBM,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,oCAAA;EAGV;EADU;IACG,iBAAA;EAGb;AACF;AAEG;EACG,eAAA;EACA,QAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAAN;AAEM;EACG,8BAAA;EACA,aAAA;EACA,mBAAA;AAAT;AAGM;EAnBH;IAoBM,kBAAA;EAAP;AACF;AAEM;EACG,4BAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAAT;AAES;EARH;IASM,iBAAA;EACV;AACF;AACS;EAZH;IAaM,0BAAA;IACA,mBAAA;EAEV;AACF;AAAS;EACG,UAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;AAEZ;AACS;EACG,kCAAA;EACA,kBAAA;AACZ;AAES;EACG,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAAZ;AAEY;EAPH;IAQM,cAAA;EACb;AACF;AACY;EACG,iBAAA;AACf;AAGS;EACG,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AADZ;AAGY;EAbH;IAcM,SAAA;IACA,WAAA;EAAb;AACF;AAEY;EACG,eAAA;EACA,mBAAA;AAAf;AAIS;EACG,aAAA;EACA,mBAAA;AAFZ;AAIY;EAJH;IAKM,cAAA;EADb;AACF;AAGY;EARH;IASM,aAAA;IACA,sBAAA;EAAb;AACF;AAEY;;EAEG,UAAA;EACA,gBAAA;AAAf;AAEe;EALH;;IAMM,SAAA;IACA,UAAA;IACA,gBAAA;EAEhB;AACF;AAAe;EAXH;;IAYM,gBAAA;EAIhB;AACF;AAFe;EAfH;;IAgBM,WAAA;EAMhB;AACF;AADY;EACG,6BAAA;EACA,UAAA;AAGf;AADe;EAJH;IAKM,6BAAA;EAIhB;AACF;AAFe;EARH;IASM,mBAAA;EAKhB;AACF;AADY;EACG,cAAA;EACA,sBAAA;AAGf","sourcesContent":[".events {\r\n   margin-top: 130px;\r\n   margin-bottom: 50px;\r\n\r\n\r\n   p.text{\r\n      max-width: 800px;\r\n      margin: 20px 0 50px 0;\r\n   }\r\n\r\n   .items {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 30px;\r\n\r\n      @media (max-width: 780px) {\r\n         gap: 100px;\r\n      }\r\n\r\n      @media (max-width: 550px) {\r\n         gap: 80px;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n         gap: 60px;\r\n      }\r\n\r\n      .item {\r\n         position: relative;\r\n         background-color: var(--red);\r\n         box-sizing: border-box;\r\n         display: flex;\r\n         justify-content: space-between;\r\n         gap: 40px;\r\n\r\n         @media (max-width: 1350px) {\r\n            gap: 20px;\r\n         }\r\n\r\n         .index {\r\n            padding: 0 30px 0 20px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            @media (max-width: 1350px) {\r\n               padding: 0 10px 0 20px;\r\n            }\r\n\r\n            @media (max-width: 640px) {\r\n               display: none;\r\n            }\r\n\r\n            h3 {\r\n               font-size: 7.5rem;\r\n               margin: 0;\r\n               font-family: 'Rubik Glitch';\r\n               font-weight: 400;\r\n               color: var(--white);\r\n\r\n               @media (max-width: 1350px) {\r\n                  font-size: 6.8rem;\r\n               }\r\n            }\r\n         }\r\n\r\n         .box_info {\r\n            width: 100%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            align-items: flex-start;\r\n            gap: 20px;\r\n            padding: 0 20px 0 0;\r\n\r\n            @media (max-width: 780px) {\r\n               .btn {\r\n                  position: absolute;\r\n                  border: 0;\r\n                  top: calc(100% + 15px);\r\n                  right: -10px;\r\n\r\n                  @media (max-width: 480px) {\r\n                     top: calc(100% + 5px);\r\n                     right: -12px;\r\n                  }\r\n               }\r\n            }\r\n\r\n            @media (max-width: 640px) {\r\n               padding: 0 20px 0 5px;\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               padding: 0 10px 0 2px;\r\n            }\r\n\r\n            h2 {\r\n               font-family: \"Beer money\";\r\n               font-size: 2rem;\r\n               font-weight: 400;\r\n\r\n               @media (max-width: 640px) {\r\n                  font-size: 1.9rem;\r\n               }\r\n\r\n               @media (max-width: 480px) {\r\n                  font-size: 1.7rem;\r\n               }\r\n            }\r\n\r\n            h2,\r\n            p {\r\n               color: var(--white);\r\n               margin: 0;\r\n            }\r\n         }\r\n\r\n         .foto {\r\n            img {\r\n               box-sizing: border-box;\r\n               height: 100%;\r\n               max-height: 320px;\r\n               border: 10px solid var(--white);\r\n               border-radius: 50%;\r\n\r\n               @media (max-width: 780px) {\r\n                  border: 8px solid var(--white);\r\n                  transform: scale(1.2);\r\n               }\r\n\r\n               @media (max-width: 550px) {\r\n                  border: 5px solid var(--white);\r\n               }\r\n            }\r\n\r\n            @media (max-width: 1350px) {\r\n               max-height: 260px;\r\n               max-width: 260px;\r\n            }\r\n\r\n            @media (max-width: 1080px) {\r\n               max-height: 200px;\r\n               max-width: 200px;\r\n            }\r\n\r\n            @media (max-width: 550px) {\r\n               max-height: 140px;\r\n               max-width: 140px;\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               max-height: 100px;\r\n               max-width: 100px;\r\n            }\r\n         }\r\n      }\r\n\r\n      // 1\r\n      .item:nth-child(odd) {\r\n         margin-right: 100px;\r\n         border-radius: 0 200px 200px 0;\r\n\r\n         .foto {\r\n            margin-right: -15px;\r\n         }\r\n\r\n         @media (max-width: 1350px) {\r\n            margin-right: 40px;\r\n         }\r\n\r\n         @media (max-width: 780px) {\r\n            margin-right: 20px;\r\n            border-radius: 40px 200px 200px 40px;\r\n         }\r\n      }\r\n\r\n      // 2\r\n      .item:nth-child(even) {\r\n         margin-left: 100px;\r\n         flex-direction: row-reverse;\r\n         width: 100%;\r\n         border-radius: 200px 0 0 200px;\r\n\r\n         .index {\r\n            margin-right: 200px;\r\n         }\r\n\r\n         .foto {\r\n            margin-left: -15px;\r\n         }\r\n\r\n         @media (max-width: 1350px) {\r\n            margin-left: 40px;\r\n            width: calc(100% + 60px);\r\n\r\n            .index {\r\n               margin-right: 150px;\r\n            }\r\n         }\r\n\r\n\r\n         @media (max-width: 780px) {\r\n            margin-left: 0px;\r\n            margin-right: 20px;\r\n            flex-direction: row;\r\n            width: 100%;\r\n            border-radius: 40px 200px 200px 40px;\r\n\r\n            .index {\r\n               margin-right: 0px;\r\n            }\r\n         }\r\n      }\r\n   }\r\n\r\n   .bg_popup {\r\n      position: fixed;\r\n      inset: 0;\r\n      background: rgba(217, 217, 217, 0.1);\r\n      backdrop-filter: blur(10px);\r\n      z-index: 105;\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: center;\r\n      padding: 40px;\r\n      max-height: 100%;\r\n      overflow-y: auto;\r\n\r\n      .bg_height{\r\n         min-height: calc(100vh - 80px);\r\n         display: flex;\r\n         align-items: center;\r\n      }\r\n\r\n      @media (max-width: 640px) {\r\n         padding: 40px 20px;\r\n      }\r\n\r\n      .box_popup {\r\n         border: 5px solid var(--red);\r\n         background-color: var(--white);\r\n         position: relative;\r\n         margin: 50px 100px;\r\n         padding: 5vh 3rem;\r\n         box-sizing: border-box;\r\n\r\n         @media (max-width: 1420px) {\r\n            margin: 50px 20px;\r\n         }\r\n\r\n         @media (max-width: 640px) {\r\n            margin: 0px 0px !important;\r\n            padding: 4vh 1.5rem;\r\n         }\r\n\r\n         &::-webkit-scrollbar {\r\n            width: 8px;\r\n            background-color: rgba(26, 24, 47, 0.15);\r\n            border-radius: 5px;\r\n            height: 200px;\r\n         }\r\n\r\n         &::-webkit-scrollbar-thumb {\r\n            background: rgba(255, 0, 0, 0.101);\r\n            border-radius: 8px;\r\n         }\r\n\r\n         h2 {\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            margin: 0;\r\n            max-width: 90%;\r\n            font-size: 2rem;\r\n\r\n            @media (max-width: 768px) {\r\n               max-width: 80%;\r\n            }\r\n\r\n            strong {\r\n               color: var(--red);\r\n            }\r\n         }\r\n\r\n         .close {\r\n            position: absolute;\r\n            top: 25px;\r\n            right: 25px;\r\n            padding: 4px 6px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: var(--red);\r\n            border-radius: 50%;\r\n            cursor: pointer;\r\n            border: none;\r\n\r\n            @media (max-width: 480px) {\r\n               top: 15px;\r\n               right: 15px;\r\n            }\r\n\r\n            i {\r\n               font-size: 25px;\r\n               color: var(--white);\r\n            }\r\n         }\r\n\r\n         .col {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            @media (max-width: 920px) {\r\n               display: block;\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               display: flex;\r\n               flex-direction: column;\r\n            }\r\n\r\n            .img_card_1,\r\n            .img_card_2 {\r\n               width: 25%;\r\n               max-width: 350px;\r\n\r\n               @media (max-width: 920px) {\r\n                  margin: 0;\r\n                  width: 50%;\r\n                  max-width: 350px;\r\n               }\r\n\r\n               @media (max-width: 640px) {\r\n                  max-width: 250px;\r\n               }\r\n\r\n               @media (max-width: 480px) {\r\n                  width: 100%;\r\n               }\r\n   \r\n            }\r\n\r\n\r\n            .img_card_1 {\r\n               margin: 150px -90px 10px 10px;\r\n               z-index: 2;\r\n\r\n               @media (max-width: 1280px) {\r\n                  margin: 120px -70px 10px 10px;\r\n               }\r\n\r\n               @media (max-width: 920px) {\r\n                  margin: 0 -20px 0 0;\r\n               }\r\n\r\n            }\r\n\r\n            .img_card_2 {\r\n               margin: 10px 0;\r\n               align-self: flex-start;\r\n\r\n               // @media (max-width: 920px) {\r\n               //    margin: -30px 0 0 0;\r\n               //    transform: rotate(20deg);\r\n               //    align-self: flex-end;\r\n               // }\r\n            }\r\n         }\r\n      }\r\n   }\r\n}\r\n\r\n// .col{\r\n//    display: flex;\r\n//    align-items: center;\r\n\r\n//    img{\r\n//       max-width: 350px;\r\n//    }\r\n\r\n//    .img_card_1{\r\n//       margin: 200px -80px 10px 10px;\r\n//       z-index: 2;\r\n//    }\r\n//    .img_card_2{\r\n//       margin: 10px 0;\r\n//       align-self: flex-start;\r\n//    }\r\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"events": `Events_events__pI5RN`,
	"text": `Events_text__q2grb`,
	"items": `Events_items__e5o+x`,
	"item": `Events_item__-ny2n`,
	"index": `Events_index__EQkPy`,
	"box_info": `Events_box_info__gvnjS`,
	"btn": `Events_btn__3g9VQ`,
	"foto": `Events_foto__S0xQx`,
	"bg_popup": `Events_bg_popup__hwAPl`,
	"bg_height": `Events_bg_height__TH7ab`,
	"box_popup": `Events_box_popup__al+Ka`,
	"close": `Events_close__xI-AI`,
	"col": `Events_col__CCIbH`,
	"img_card_1": `Events_img_card_1__cplHJ`,
	"img_card_2": `Events_img_card_2__jz++N`
};
export default ___CSS_LOADER_EXPORT___;
